import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { uuid } from "core/utils";
import BackArrowSvg from 'themes/components/steps/BackArrowSvg';
import FrontArrowSvg from 'themes/components/steps/FrontArrowSvg';

function FacilityOrderNewFlowStatusBarTemplate({ facilityOrderNewFlowStatusBarViewStore, children }) {
    const {
        showHideStatusBar,
        isStatusBarVisible,
        openPage,
        getStatusButtonClassName,
        title,
        getUserAndDateCompleted,
        isStatusBarAllowed,
        showInventoryButton,
        showBillingButton,
        activeBar,
    } = facilityOrderNewFlowStatusBarViewStore;
    const id = uuid();

    return (
        <div>
            <div className="content__header u-flex--primary is-nested">
                <h2>
                    {title}
                </h2>
                {isStatusBarAllowed &&
                    <div onClick={() => showHideStatusBar()} className='content__header__btn'><i className={` ${isStatusBarVisible ? 'u-rotate--180' : ''} u-icon u-icon--xsml u-icon--arrow-down--text`}></i></div>
                }
                <div className="u-flex--default u-mar--left--auto">
                    {children}
                </div>
                {isStatusBarAllowed && isStatusBarVisible &&
                    <div className='btn--progress__wrapper'>
                        <ReactTooltip
                            positionStrategy="fixed"
                            id={"registerTip" + id}
                            place="bottom"
                            render={({ activeAnchor }) => {
                                const html = activeAnchor?.getAttribute("data-tooltip-html");
                                return html ? <span dangerouslySetInnerHTML={{ __html: html }} /> : null;
                            }}
                        />
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("initial-intake")} is-first ${activeBar === 'initial' ? 'is-active' : ''}`}
                            onClick={() => openPage("initial-intake")}
                            icon="u-icon u-icon--sml btn--new-progress__icon"
                            data-tooltip-html={`${getStatusButtonClassName("initial-intake") === "is-completed" ? getUserAndDateCompleted("initial-intake") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={activeBar === 'initial' ? 'is-active' : ''} status={getStatusButtonClassName("initial-intake")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Initial intake
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={activeBar === 'initial' ? 'is-active' : ''} status={getStatusButtonClassName("initial-intake")} />
                            </div>
                        </button>
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("insurance-review")} ${activeBar === 'insurance' ? 'is-active' : ''}`}
                            onClick={() => openPage("insurance-review")}
                            data-tooltip-html={`${getStatusButtonClassName("insurance-review") === "is-completed" ? getUserAndDateCompleted("insurance-review") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={activeBar === 'insurance' ? 'is-active' : ''} status={getStatusButtonClassName("insurance-review")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Insurance Review
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={activeBar === 'insurance' ? 'is-active' : ''} status={getStatusButtonClassName("insurance-review")} />
                            </div>
                        </button>
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("us-intake")} ${activeBar === 'us-intake' ? 'is-active' : ''}`}
                            onClick={title === "US Intake" ? null : () => openPage("us-intake")}
                            data-tooltip-html={`${getStatusButtonClassName("us-intake") === "is-completed" ? getUserAndDateCompleted("us-intake") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                            style={{ cursor: title === "US Intake" ? "default" : "pointer" }}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={activeBar === 'us-intake' ? 'is-active' : ''} status={getStatusButtonClassName("us-intake")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                US Intake
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={activeBar === 'us-intake' ? 'is-active' : ''} status={getStatusButtonClassName("us-intake")} />
                            </div>
                        </button>
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("clinical-review")} ${activeBar === 'clinical' ? 'is-active' : ''}`}
                            onClick={title === "Clinical Review" ? null : () => openPage("clinical-review")}
                            data-tooltip-html={`${getStatusButtonClassName("clinical-review") === "is-completed" ? getUserAndDateCompleted("clinical-review") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                            style={{ cursor: title === "Clinical Review" ? "default" : "pointer" }}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={activeBar === 'clinical' ? 'is-active' : ''} status={getStatusButtonClassName("clinical-review")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Clinical Review
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={activeBar === 'clinical' ? 'is-active' : ''} status={getStatusButtonClassName("clinical-review")} />
                            </div>
                        </button>
                        {showInventoryButton && <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("inventory")} ${activeBar === 'inventory' ? 'is-active' : ''}`}
                            onClick={title.includes("Facility Inventory:") ? null : () => openPage("inventory")}
                            data-tooltip-html={`${getStatusButtonClassName("inventory") === "is-completed" ? getUserAndDateCompleted("inventory") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                            style={{ cursor: title.includes("Facility Inventory:") === "Inventory" ? "default" : "pointer" }}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={activeBar === 'inventory' ? 'is-active' : ''} status={getStatusButtonClassName("inventory")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Inventory
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={activeBar === 'inventory' ? 'is-active' : ''} status={getStatusButtonClassName("inventory")} />
                            </div>
                        </button>}
                        <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("order-summary")} ${activeBar === 'order-summary' ? 'is-active' : ''}`}
                            onClick={() => openPage("order-summary")}
                            data-tooltip-html={`${getStatusButtonClassName("order-summary") === "is-completed" ? getUserAndDateCompleted("order-summary") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg status={getStatusButtonClassName("order-summary")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Order Summary
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg status={getStatusButtonClassName("order-summary")} />
                            </div>
                        </button>
                        {showBillingButton && <button
                            className={`btn btn--new-progress ${getStatusButtonClassName("billing")} is-last ${activeBar === 'billing' ? 'is-active' : ''}`}
                            onClick={() => openPage("billing")}
                            data-tooltip-html={`${getStatusButtonClassName("billing") === "is-completed" ? getUserAndDateCompleted("billing") : ""}`}
                            data-tooltip-id={"registerTip" + id}
                        >
                            <div className='btn--new-progress__back'>
                                <BackArrowSvg className={activeBar === 'billing' ? 'is-active' : ''} status={getStatusButtonClassName("billing")} />
                            </div>
                            <div className='btn--new-progress__btn'>
                                <i className="u-icon u-icon--sml btn--new-progress__icon"></i>
                                Billing
                            </div>
                            <div className='btn--new-progress__front'>
                                <FrontArrowSvg className={activeBar === 'billing' ? 'is-active' : ''} status={getStatusButtonClassName("billing")} />
                            </div>

                        </button>}
                    </div>
                }
            </div>
        </div>
    )
}

FacilityOrderNewFlowStatusBarTemplate.propTypes = {
    facilityOrderNewFlowStatusBarViewStore: PropTypes.object,
    children: PropTypes.any,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderNewFlowStatusBarTemplate);
